import {
    Badge, Button, ErrorIcon, FolderCloseIcon, Pane, PeopleIcon,
    Table,
} from "evergreen-ui";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Store } from "../../../../common/models";
import { CenteredSpinner } from "../../common/CenteredSpinner";
import { EmptyState } from "../../common/EmptyState";
import { useStoreListQuery } from "../../datastore/StoreDataStore";
import { NavigationHelper } from "../../navigation/PrevLocationState";

// TODO: Consolidate store dialog with StoreSelector
export const UserStoreListPage = () => {
    const history = useHistory();
    const [stores, setStores] = useState<Store[]>([]);
    const { loading, error, data } = useStoreListQuery();

    useEffect(() => {
        if (!loading) {
            setStores(data || []);
        }
    }, [data, loading]);

    if (loading) {
        return <CenteredSpinner />;
    }

    if (error || !data) {
        return (
            <EmptyState
                title="Failed to load stores"
                subtitle="Refresh the page to try again"
            >
                <ErrorIcon size={60} />
            </EmptyState>
        );
    }

    const goToUserManagementPage = (event: React.MouseEvent<HTMLElement>, storeId: string) => {
        event.stopPropagation();
        history.push(NavigationHelper.createStoreTeamManagementPath(storeId));
    };

    const renderManageCollaboratorsButton = (storeId: string) => {
        return (
            <Button
                appearance={"minimal"}
                onClick={
                    (event: React.MouseEvent<HTMLElement>) => goToUserManagementPage(event, storeId)
                }
                iconBefore={PeopleIcon}>
                Manage Team
            </Button>
        );
    }

    return (stores.length === 0) ? (
        <EmptyState
            title="You don’t have any stores right now."
            subtitle=""
        >
            <FolderCloseIcon size={60} />
        </EmptyState>
    ) : (
        <Pane className="jc-content-page">
            <Pane
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
                alignItems="center"
            >
                <h2>Stores</h2>
            </Pane>
            <Table marginY={20}>
                <Table.Head height={40}>
                    <Table.TextHeaderCell>Store Name</Table.TextHeaderCell>
                    <Table.TextHeaderCell>Collaborators</Table.TextHeaderCell>
                </Table.Head>
                <Table.Body>
                    {stores.map(({ id, name, isPartnershipsTier }) => {
                        return (
                            <Table.Row
                                key={id}
                                isSelectable={!isPartnershipsTier}
                                onSelect={() => {
                                    history.push(NavigationHelper.createStorePath(id));
                                }}
                            >
                                <Table.TextCell>
                                    {name}
                                    {isPartnershipsTier ? <Badge color="green" marginX={8}>
                                        Partnerships
                                    </Badge> : null}
                                </Table.TextCell>
                                <Table.TextCell>
                                    {renderManageCollaboratorsButton(id)}
                                </Table.TextCell>
                            </Table.Row>
                        );
                    })}
                </Table.Body>
            </Table>
            <Pane display={"flex"} justifyContent={"center"} textAlign={"center"} marginY={"60px"}>
                <span>
                    <Pane marginBottom={"8px"}>
                        Click “New Store” to start a new store.
                    </Pane>
                    <Pane>
                        This doesn’t apply for Partnerships stores.
                    </Pane>
                </span>
            </Pane>
        </Pane>
    );
}
